var PD = PD || {};
PD.windows = PD.windows || {};

//------------------------------------------------------------------------------
// notify singleton
//------------------------------------------------------------------------------
PD.windows.notify = PD.windows.notify || (function(n){
  var _container = $("<div class='cm-notification-container'></div>"); // so we don't error if it's called too quickly (we simply fail)
  $(function(){ // insert element as soon as DOM is ready
    _container.appendTo("body");
  });

  var _classes = ["info", "success", "warning", "danger"];

  /**
   * Notifications class
   * @param {String} title   The title of the notification. Shown in bold
   * @param {String} content The HTML content of the notification
   * @param {Object} options An options object of format
   * {
   *   _class: <String>,           // one of the classes listed in `_classes` above
   *   sticky: <Boolean>,          // set to `true` to stop automatic hiding. Should only be used if you add manual way to hide (eg. action)
   *   close: <Boolean>,           // set to `true` to add close button
   *   removeListener: <Function>, // function to call once the notification is removed
   *   actions: [{                 // buttons to display in notification. Suggested maximum of 2
   *     text: <String>,           // text content of button
   *     click: <Function|String>, // function to call once button is clicked
   *                               // can also be the string "hide" to destroy the notification
   *     classes: ["a", "b"]       // classes to add to the button
   *   }, {
   *     ...
   *   }]
   * }
   */
  function Notification(title,content,options) {
    this.opts = options || {};
    if (_classes.indexOf(this.opts._class) === -1) { // if it's an invalid class
      console.warn("[PD.windows.notify] Invalid class '"+this.opts._class+"', defaulting to info. Possible classes: "+_classes.join(","));
      this.opts._class = "info";
    }
    if (!_container.length) {
      return console.warn("[PD.windows.notify] Attempted to create notification before DOM was ready");
      // TODO: queue up notification so it is created when DOM is ready
    }
    this.removeListener = this.opts.removeListener;

    // create
    var self = this;
    this.$elm = $( $.tmpl('<div class="cm-notification alert-<%= options._class %>"><% if (options.close) { %><button type="button" class="close" aria-label="close"><span aria-hidden="true">&times;</span></button><% } %><strong><%= title %></strong><%= content %><% if (options.actions) { %><% for (var i = 0; i < options.actions.length; ++i) { %><button class="<%= (options.actions[i].classes || []).join(\' \') %>"><%= options.actions[i].text %></button><% } %><% } %></div>', {
        title: title,
        content: content,
        options: this.opts
      }) );
    this.$elm.appendTo(_container);

    // bind buttons
    $("button:not(.close)", this.$elm).each(function(i,elm){
      var func = self.opts.actions[i].click;
      if (func === "hide") {
        func = self.hide.bind(self, true);
      }

      $(elm).click(func);
    });
    $(".close", this.$elm).on("click", self.hide.bind(self));

    // add sticky class or auto-hide
    if (this.opts.sticky) {
      this.$elm.addClass("cm-notification-sticky");
    } else {
      this.hideTimer = setTimeout(function(){ // wait for 10 seconds
        // then start removing self
        self.hide();
      }, 10000);
    }

    // handle hovers
    this.$elm.on("mouseenter", function(e){
      if (self.force) {
        return;
      }
      self.hovering = true;
      self.$elm.removeClass("cm-notification-hiding");

      // if we're waiting to remove, stop it
      clearTimeout(self.hideTimer);

      // if we're in the process of removing, stop it
      clearTimeout(self.removeTimer);
    });
    this.$elm.on("mouseleave", function(e){
      self.hovering = false;

      // wait 3s before hiding
      if (!self.opts.sticky) {
        self.hideTimer = setTimeout(function(){
          self.hide();
        }, 3000);
      }
    });
  }
  /**
   * Start hiding (with a short warning scaleOut, in which the user can stop it)
   */
  Notification.prototype.hide = function(force){
    if (this.hovering && !force) { // if user is hovering
      this.hideOverdue = true; // tell event listeners that we want to be removed
      return;
    }

    this.force = true;
    this.removing = true;
    this.hideOverdue = true; // the use for this has been removed. Leaving it in in case it'll be useful later
    this.$elm.addClass("cm-notification-hiding");
    var self = this;
    // start warning scaleOut - animation is handled in CSS, and should be 1.5 seconds long
    this.removeTimer = setTimeout(function(){
      self.remove();
    }, 250);
  };
  /**
   * Actually remove the element - this should happen after warning scaleOut
   */
  Notification.prototype.remove = function(){
    this.hideOverdue = false;
    clearTimeout(this.hideTimer);
    clearTimeout(this.removeTimer);
    this.$elm.remove();
    if (this.removeListener) {
      this.removeListener();
    }
  };
  n.Notification = Notification;

  // create a method for each class
  function _createNotification(_class,title,content,options){
    var opts = $.extend({}, options || {}, {_class: _class});
    return new Notification(title, content, opts);
  }
  for (var i = 0; i < _classes.length; ++i) {
    n[_classes[i]] = _createNotification.bind(null, _classes[i]);
  }

  return n;
})({});